import { z } from 'zod';

const phoneNumberRegex = /^(\+91|91)?[6-9]\d{9}$/;
const aadharRegex = /^\d{4}[- ]?\d{4}[- ]?\d{4}$|^\d{12}$/;

export const CreateResidentSchema = z.object({
  bedNumber: z.string().min(1, 'Bed number is required').max(10, 'Bed number cannot exceed 10 characters'),
  name: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name cannot exceed 100 characters')
    .regex(/^[a-zA-Z\s.-]+$/, 'Name can only contain letters, spaces, dots and hyphens'),
  contactNumber: z.string().min(10, 'Contact number is required').regex(phoneNumberRegex, 'Please enter a valid Indian mobile number'),
  emergencyContact: z.string().regex(phoneNumberRegex, 'Invalid emergency contact number').optional().or(z.literal('')),
  aadharNumber: z.string().regex(aadharRegex, 'Aadhar must be 12 digits (with or without spaces)').optional().or(z.literal('')),
  address: z.string().max(500, 'Address cannot exceed 500 characters').optional().or(z.literal('')),
  admissionDate: z
    .union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (YYYY-MM-DD)'), z.date()])
    .transform((val) => (typeof val === 'string' ? new Date(val) : val)),
  joiningDate: z
    .union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (YYYY-MM-DD)'), z.date()])
    .transform((val) => (typeof val === 'string' ? new Date(val) : val)),
  monthlyRent: z.number({ invalid_type_error: 'Monthly rent must be a number' }).min(1000, 'Rent must be at least ₹1,000').max(50000, 'Rent cannot exceed ₹50,000'),
  depositAmount: z.number({ invalid_type_error: 'Deposit amount must be a number' }).min(0, 'Deposit cannot be negative').max(100000, 'Deposit cannot exceed ₹1,00,000'),
  depositPaidDate: z
    .union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (YYYY-MM-DD)'), z.date()])
    .transform((val) => (typeof val === 'string' ? new Date(val) : val)),
  remarks: z.string().max(500, 'Remarks cannot exceed 500 characters').optional().or(z.literal('')),
});

export type CreateResidentInput = z.infer<typeof CreateResidentSchema>;
